/**
 * 品牌图片工具函数
 * 用于获取品牌logo图片路径
 */

// 品牌名称到文件名的映射
const brandFileMap = {
  'Burton': 'burton.jpg',
  'Nitro': 'nitro.jpeg',
  'Capita': 'capita.jpg',
  'Arbor': 'arbor.jpg',
  'K2': 'k2.jpg',
  'Salomon': 'salomon.jpg',
  'Jones': 'jones.jpg',
  'YES': 'yes.jpg',
  'Lib Tech': 'libtech.jpg',
  'GNU': 'gnu.jpg',
  'Rome': 'rome_sds.jpg',
  'Union': 'union.jpg',
  'Adidas': 'adidas.jpg',
  'Nike': 'nike.jpg',
  'DC': 'dc.jpg',
  'Vans': 'vans.jpeg',
  'ThirtyTwo': 'thirtytwo.jpg',
  'Flow': 'flow.jpg',
  'Drake': 'drake.jpg',
  'SP': 'sp.jpeg',
  'Flux': 'flux.png',
  'NOW': 'now.jpg',
  'Ride': 'ride.jpg',
  'Never Summer': 'never_summer.jpg',
  'Bataleon': 'bataleon.jpg',
  'Deeluxe': 'dalbello.jpg',
  'Smokin': 'smokin.jpg',
  'Nobaday零夏': 'nobaday.jpg',
  'BC Stream': 'bc_stream.jpg',
  'Lobster': 'lobster.jpg',
  'Roxy': 'roxy.jpg',
  'Northwave': 'northwave.jpg',
  'Kessler': 'kessier.jpg',
  'Spread': 'signal.jpg',
  'Yonex': 'yes.jpg',
  'Gray': 'giro.jpg',
  'Nidecker': 'nidecker.jpg',
  'CLEW': 'clvvr.jpg',
  'November': 'november.jpg',
  'Korua Shapes': 'korua.jpg',
  'Ogasaka': 'ogasaka.jpg',
  'Rice28': 'r.jpg',
  '011': '011.jpg'
};

/**
 * 获取品牌logo图片路径
 * @param {string} brandName - 品牌名称
 * @returns {string} 图片路径
 */
export const getBrandImagePath = (brandName) => {
  if (!brandName) return '';
  
  // 首先检查映射表
  if (brandFileMap[brandName]) {
    return `/images/brands/${brandFileMap[brandName]}`;
  }

  // 检查忽略大小写的映射表
  const lowerBrandName = brandName.toLowerCase();
  const mapKey = Object.keys(brandFileMap).find(key => key.toLowerCase() === lowerBrandName);
  if (mapKey) {
    return `/images/brands/${brandFileMap[mapKey]}`;
  }
  
  // 将品牌名称转换为小写并替换空格为下划线
  const normalizedBrandName = brandName
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, ''); // 移除特殊字符
  
  // 默认返回jpg格式
  return `/images/brands/${normalizedBrandName}.jpg`;
};

/**
 * 获取品牌logo图片，带有错误处理
 * @param {string} brandName - 品牌名称
 * @param {string} fallbackImage - 备用图片路径
 * @returns {string} 图片路径
 */
export const getBrandImage = (brandName, fallbackImage = '/images/brands/burton.jpg') => {
  if (!brandName) return fallbackImage;
  
  return getBrandImagePath(brandName);
};

/**
 * 预加载品牌图片
 * @param {string} brandName - 品牌名称
 * @returns {Promise} 图片加载Promise
 */
export const preloadBrandImage = (brandName) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load brand image: ${brandName}`));
    img.src = getBrandImagePath(brandName);
  });
};

/**
 * 检查品牌图片是否存在
 * @param {string} brandName - 品牌名称
 * @returns {Promise<boolean>} 是否存在
 */
export const checkBrandImageExists = async (brandName) => {
  try {
    await preloadBrandImage(brandName);
    return true;
  } catch {
    return false;
  }
};